'use client'

import { Code, Smartphone, Zap, Search } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function WebDevelopmentPage() {
  return (
    <ServicePageTemplate
      slug="web-development"
      title="Web"
      titleHighlight="Development"
      description="Create stunning, high-performance websites and web applications that engage users and drive business results."
      accentColor="from-sky-500 to-blue-600"
      stats={[
        { value: '500+', label: 'Websites Delivered' },
        { value: '98%', label: 'Performance Score' },
        { value: '4.9★', label: 'Client Rating' },
        { value: '24/7', label: 'Support Available' }
      ]}
      services={[
        { icon: <Code className="w-6 h-6" />, title: 'Custom Website Development', description: 'Tailored websites built from scratch using modern technologies.', features: ['Custom Design & Development', 'Responsive Design', 'Performance Optimization', 'SEO Integration'] },
        { icon: <Smartphone className="w-6 h-6" />, title: 'Responsive Web Design', description: 'Mobile-first designs that work perfectly on all devices.', features: ['Mobile-First Approach', 'Cross-Browser Compatibility', 'Touch-Friendly Interface', 'Adaptive Images'] },
        { icon: <Zap className="w-6 h-6" />, title: 'Web Applications', description: 'Complex web applications with advanced functionality.', features: ['Single Page Applications', 'Progressive Web Apps', 'Real-time Features', 'API Integration'] },
        { icon: <Search className="w-6 h-6" />, title: 'CMS Development', description: 'Content management systems for easy content management.', features: ['WordPress Development', 'Headless CMS', 'Custom Admin Panels', 'User Management'] },
      ]}
      technologies={[
        { name: 'React', category: 'Frontend' }, { name: 'Next.js', category: 'Full-Stack' },
        { name: 'Vue.js', category: 'Frontend' }, { name: 'Node.js', category: 'Backend' },
        { name: 'TypeScript', category: 'Language' }, { name: 'GraphQL', category: 'API' },
        { name: 'MongoDB', category: 'Database' }, { name: 'AWS', category: 'Cloud' },
      ]}
      process={[
        { step: '01', title: 'Requirements Analysis', description: 'Deep dive into business needs, target audience, and project goals.' },
        { step: '02', title: 'Design & Prototyping', description: 'Wireframes, mockups, and interactive prototypes.' },
        { step: '03', title: 'Frontend Development', description: 'Responsive, interactive UIs using modern technologies.' },
        { step: '04', title: 'Backend Development', description: 'Robust server-side logic, APIs, and database architecture.' },
        { step: '05', title: 'Testing & QA', description: 'Comprehensive testing for functionality, performance, and security.' },
        { step: '06', title: 'Deployment & Support', description: 'Launch with proper hosting and ongoing maintenance.' },
      ]}
    />
  )
}
